import { render } from "./builderPostDetails.vue?vue&type=template&id=d4cbd340&scoped=true"
import script from "./builderPostDetails.vue?vue&type=script&lang=js"
export * from "./builderPostDetails.vue?vue&type=script&lang=js"

import "./builderPostDetails.vue?vue&type=style&index=0&id=d4cbd340&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4cbd340"]])

export default __exports__